// R114 fix2 — sticky / fixed action bars at the bottom of a screen (the
// inspection report's Complete / Edit scoring bar, the capture screen's
// Save & exit / Continue bar, the Issues bulk bar, the Jarvis composer, the
// Quick-log footer, any [data-bottom-bar]). The app-wide floating pills
// (PhotoQueuePill, InfoAskPill) must never sit on one at phone width: the
// photo pill steps aside, the office-question pill lifts above it.
export const BOTTOM_BARS = '.rc-actions, .cap-analyze-bar, .iss-bulk, .jv-composer, .qli-foot, [data-bottom-bar]';

/** A bottom bar is rendered on this screen (display:none ones do not count). */
export function bottomBarShown(): boolean {
  for (const n of Array.from(document.querySelectorAll<HTMLElement>(BOTTOM_BARS))) if (n.getClientRects().length) return true;
  return false;
}

/**
 * How many px above the viewport bottom a floating element must sit so it
 * clears every bottom bar under it — 0 when none is in the way. `el` (the
 * floating element) gives the horizontal extent and height; `base` is its
 * normal distance from the bottom.
 */
export function bottomBarClearance(el: HTMLElement, base: number): number {
  const vh = window.innerHeight;
  const me = el.getBoundingClientRect();
  const h = me.height || 48;
  const left = me.left, right = me.right || window.innerWidth;
  let need = 0;
  for (const n of Array.from(document.querySelectorAll<HTMLElement>(BOTTOM_BARS))) {
    if (!n.getClientRects().length) continue;
    const r = n.getBoundingClientRect();
    if (r.right <= left || r.left >= right) continue;                  // not under it
    if (r.top >= vh - base || r.bottom <= vh - base - h) continue;     // not in its band
    need = Math.max(need, Math.ceil(vh - r.top) + 8);
  }
  return need;
}
